export default __webpack_public_path__ + "static/media/curriculum-svgrepo-com-ok.821fd1bc.svg";